import {
    IContent,
    IMediaCanvas,
    IMediaVideo
} from 'mod/featureV2/interface/parallax';

export const DEFAULT_VIDEO_STAY = 100; //video默认停留帧数
export const DEFAULT_FRAME_DISTANCE = 25; //每帧对应的滚动距离

type IStatusMediaCommon = {
    mediaIndex: number; //媒体索引
    start: number; //开始帧
    end: number; //结束帧
    height: number; //总滚动距离
    loaded: boolean;
}

export type IStatusCanvasImage = {
    unextendedIndex: number;
    image: HTMLImageElement | null;
};

export type IStatusCanvas = IMediaCanvas & IStatusMediaCommon & {
    elem: HTMLCanvasElement;
    frameScrollDistance: number; //没配置时使用默认值
    extendFrames: Record<number, number>; //使用{}赋值, 方便后面使用
    images: Array<IStatusCanvasImage>
}

export type IStatusVideo = IMediaVideo & IStatusMediaCommon & {
    elem: HTMLVideoElement;
    stay: number; //没配置时使用默认值
};

export type IStatusContent = Omit<IContent, 'component'> & {
    elem: HTMLDivElement;
    startTop: number;
    endTop: number;
}

export type IParallaxStatus = {
    parallax: HTMLDivElement;
    medias: Array<IStatusCanvas | IStatusVideo>;
    contentList: Array<IStatusContent>;
    framesLen: number; //总帧数
    activeTop: number;
    activeIndex: number;
    activeMedia: IStatusCanvas | IStatusVideo | null;
    scrollLock: boolean;
    screenW: number;
    screenH: number;
    parallaxH: number;
    hideStart: number;
    hideEnd: number;
    intervalId: number;
    debugActiveIndex: HTMLDivElement;
    debugUnextendedIndex: HTMLDivElement;
    cover: HTMLDivElement | null;
    loaded: boolean;
    running: boolean; //超出可视范围时不执行各种计算
    inViewport: boolean; //是否在视口内
};